const prodConfig = {
  apiKey: "rzp_live_iJcBvpNpCc9E6F",
  secret: "2XSdbKV7zmdQUfufxMACNq99",
};
const devConfig = {
  apiKey: "rzp_test_KWSehuno9ktquq",
  secret: "EshQ5vxraoRivGRxotgijVXM",
};
export const config = prodConfig;
// process.env.NODE_ENV === "production" ? prodConfig : devConfig;
